// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2WgR1","author":"Table_author__3lZLz","authorImage":"Table_authorImage__397xR","unreadRow":"Table_unreadRow__1XuDj"};